import { styled } from "@mui/material/styles";
import { Grid, Typography, Link } from "@mui/material";

import ImageOnLoad from "components/ImageOnLoad/ImageOnLoad";
import ResponsiveImage from "components/ResponsiveImage";

export const StyledGrid = styled(Grid)({
  overflow: "hidden",
  height: "auto",
  width: "100%",
  backgroundImage: "linear-gradient(#C485FA,#FB8FF9)",
  paddingBottom: 60,
  marginBottom: 60,
});

export const RowTitle = styled("div")(({ theme }) => ({
  margin: "auto",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  height: "auto",
  width: "100%",
  [theme.breakpoints.up("tablet")]: {
    justifyContent: "center",
    margin: "20px auto",
    height: 200,
  },
}));

export const AnimatedLogo = styled(ImageOnLoad)(({ theme }) => ({
  width: 130,
  [theme.breakpoints.up("mobile")]: {
    width: 230,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 250,
  },
}));

export const TitleLogo = styled("img")(({ theme }) => ({
  width: 146,
  [theme.breakpoints.up("mobile")]: {
    width: 249,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 445,
    margin: "auto 60px",
  },
}));

export const Text = styled(Typography)(({ theme }) => ({
  margin: "20px 27px",
  color: theme.palette.common.white,
  [theme.breakpoints.up("mobile")]: {
    fontSize: theme.typography.large.fontSize,
    margin: "50px 120px",
  },
  [theme.breakpoints.up("tablet")]: {
    margin: "50px 350px",
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginTop: 30,
  color: theme.palette.common.white,
  margin: "auto 40px",
  [theme.breakpoints.up("tablet")]: {
    margin: "30px auto",
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.common.white,
}));

export const RowFaces = styled("div")(() => ({
  width: "100%",
  margin: "15px auto",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const HeadIcon = styled(ResponsiveImage)(({ theme }) => ({
  width: 200,
  marginLeft: 30,
  [theme.breakpoints.up("mobile")]: {
    width: 300,
    marginLeft: 0,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 400,
    marginLeft: 0,
  },
}));

export const WitchGif = styled(ImageOnLoad)(({ theme }) => ({
  width: 150,
  [theme.breakpoints.up("mobile")]: {
    width: 300,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 400,
  },
}));
